import React, { useState, useEffect } from "react";
import Pagination from "../../components/global/pagination/Pagination.jsx";
import columns from "../../columns/V2fxAccount/V2fxPendingAccounts.js";
import TableWithSkeleton from "../../components/global/table/TableWithSkeleton.jsx";
import ConfirmationModal from "../../components/global/modal/ConfirmationModal.jsx";
import { GetAllAccountApi, V2fxRequestAcceptRejectApi } from "../../api/request/account.js";
import toast from "react-hot-toast";
import moment from "moment";

export default function Accounts({ searchText }) {

    const [isLoading, setIsLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const [data, setData] = useState([]);
    const [v2fxAccept, setV2fxAccept] = useState(false);
    const [textAreaValue, setTextAreaValue] = useState('');
    const [v2fxRejection, setV2fxRejection] = useState(false);
    const [isReqLoading, setIsReqLoading] = useState(false);
    const [selectedV2fx, setSelectedV2fx] = useState({ vertexAccountId: null });
    const [sorter, setSorter] = useState({ SortBy: 'createdDate', SortOrder: '' });

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter?.order) {
            setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
        } else {
            setSorter({ SortBy: 'createdDate', SortOrder: '' });
        }
    };

    const setSelectedV2fxId = (vertexAccountId) => {
        setSelectedV2fx({ vertexAccountId });
    };

    const getAllAccounts = async () => {
        try {
            let params = {
                PageNumber: page,
                PageSize: pageSize,
                SearchText: searchText,
                FilterText: 'Pending',
                ...sorter
            }
            setIsLoading(true);
            const { data } = await GetAllAccountApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(
                    data?.data?.map((item) => {
                        return {
                            ...item,
                            balance: `$ ${item?.balance}`,
                            createdDate: (item?.createdDate ? moment(item?.createdDate).format("DD-MM-YYYY, hh:mm A") : null),

                            actions: (
                                <div className="flex">
                                    <button
                                        className="mr-3 ml-3"
                                        onClick={() => {
                                            setSelectedV2fxId(item);
                                            setV2fxAccept(true);
                                        }}
                                    >
                                        <img src="assets/icons/accept_icon.svg" alt="icon" width={27} />
                                    </button>
                                    <button onClick={() => {
                                        setSelectedV2fxId(item);
                                        setV2fxRejection(true)
                                    }}><img src="assets/icons/delete_icon.svg" alt="icon" width={27} /></button>
                                </div>
                            ),
                        };
                    })
                );
                setTotalRecord(data?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getAllAccounts();
    }, [page, pageSize, searchText, filter]);

    const V2fxRequestHandlerApproved = async () => {
        try {
            setIsReqLoading(true);
            let params = {
                vertexAccountId: selectedV2fx?.vertexAccountId?.vertexAccountId,
                approveReject: true,
                comment: 'Accepted by admin.',
            }
            const { data } = await V2fxRequestAcceptRejectApi(params);
            if (data?.success) {
                toast.success(data?.message);
                getAllAccounts();
            }
            setIsReqLoading(false);
        } catch (error) {
            toast.error(error?.response?.data?.message);
            setIsReqLoading(false);
        }
        setV2fxAccept(false);
    }

    const V2fxRequestHandlerRejected = async () => {
        if (!textAreaValue) {
            toast.error('Please enter a reason.');
            return;
        }
        try {
            setIsReqLoading(true);
            let params = {
                vertexAccountId: selectedV2fx?.vertexAccountId?.vertexAccountId,
                approveReject: false,
                comment: textAreaValue ? textAreaValue : 'Rejected by admin.',
            }
            const { data } = await V2fxRequestAcceptRejectApi(params);
            if (data?.success) {
                toast.success(data?.message);
                getAllAccounts();
                setTextAreaValue('');
            }
            setIsReqLoading(false);
        } catch (error) {
            toast.error(error?.response?.data?.message);
            setIsReqLoading(false);
        }
        setV2fxRejection(false);
    }

    return (
        <div>

            <div className="my-6">
                <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
                    <TableWithSkeleton
                        columns={columns}
                        data={data}
                        loading={isLoading}
                        onChange={handleTableChange}
                        page={page}
                        pageSize={pageSize}
                        index={true}
                    />
                </div>
                <Pagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
            </div>

            {/* ---- Accept-request ---- */}
            <ConfirmationModal
                isOpen={v2fxAccept}
                setIsOpen={setV2fxAccept}
                type='success'
                message='Are you sure you want to accept this request?'
                onConfirm={() => V2fxRequestHandlerApproved(true)}
                isLoading={isReqLoading}
                loadingLabel='Accepting request...'
            />

            {/* ---- Reject-request ---- */}


            <ConfirmationModal
                isOpen={v2fxRejection}
                setIsOpen={setV2fxRejection}
                message='Are you sure you want to reject this request?'
                onConfirm={() => V2fxRequestHandlerRejected(false)}
                isLoading={isReqLoading}
                loadingLabel='Rejecting request...'
                textArea={true}
                textAreaValue={textAreaValue}
                setTextAreaValue={setTextAreaValue}
                placeholder='Reason of rejection...'
            />
        </div>
    )
}